import React, { ReactElement, useCallback, useState } from 'react';
import { HeadTag } from 'shared/components';
import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import VulnerabilitesCard from './components/VulnerabilitiesCard';
import DashboardCard from './components/DashCard';
import PageHeader from 'shared/components/PageHeader';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const Vulnerabilities = (): ReactElement => {
  const [value, setTabValue] = useState<number>(0);
  const handleChange = useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      setTabValue(newValue);
    },
    []
  );
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  return (
    <>
      <PageHeader
        title="Vulnerability Management"
        description="Track and manage AI system vulnerabilities"
      />
      <Box className="vulnerabilities-management vulnerabilities">
        <HeadTag title="Vulnerabilities" />

        <Box className="vulnerabilities-wrapper">
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="AI Vulnerabilities" {...a11yProps(0)} />
              <Tab
                label={
                  <Stack direction="row" spacing={2}>
                    <Typography>Dashboard</Typography>
                  </Stack>
                }
                {...a11yProps(1)}
              />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <VulnerabilitesCard />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <DashboardCard />
          </CustomTabPanel>
        </Box>
      </Box>
    </>
  );
};

export default Vulnerabilities;
